import React from 'react';
import * as WixNewIcons from 'wix-ui-icons-common';

import { NewIconNames } from './new-icon-names';
import { SystemIconNames } from './system-icon-names';

interface Props {
  name: NewIconNames | SystemIconNames;
  size?: string;
}

export const NewIcon = ({ name, size }: Props) => {
  const NewIconComponent = WixNewIcons[name];
  return <NewIconComponent size={size} />;
};
